import { Outlet, createFileRoute } from "@tanstack/react-router";

import { caseDetailQueryOptions } from "@/features/cases/queries";
import { caseTitleCrumb } from "@/lib/crumb-resolvers";

// 注: ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
//     ここでは role check しない。
export const Route = createFileRoute("/_authenticated/enterprise/$id")({
  staticData: { crumb: caseTitleCrumb("/enterprise/$id") },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(caseDetailQueryOptions(params.id)),
  component: () => <Outlet />,
});
